import { Modal } from 'ant-design-vue';

import i18n from '@/i18n';

const noop = () => {};

const modals = {
  confirm(config) {
    const {
      header,
      content,
      confirmText = i18n.t('modal.buttons.confirm'),
      cancelText = i18n.t('modal.buttons.cancel'),
      onConfirm = noop,
      onCancel = noop,
    } = config;

    Modal.confirm({
      title: header,
      content,
      onOk: onConfirm,
      okText: confirmText,
      okType: 'danger',
      onCancel,
      cancelText,
      cancelButtonProps: { type: 'default' },
      closable: true,
    });
  },

  info(config) {
    const {
      header,
      content,
      buttonText,
      onButtonClick = noop,
      closable,
    } = config;

    Modal.info({
      title: header,
      content,
      okText: buttonText,
      okType: 'primary',
      closable,
      keyboard: closable,
      onOk: onButtonClick,
    });
  },
};

export default {
  install(Vue) {
    /* eslint-disable-next-line no-param-reassign */
    Vue.prototype.$modals = modals;
  },
};
